import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css'; 
import GoogleAnalytics from '../components/GoogleAnalytics';
const PrivacyPolicy = () => {
  return (
    <div>
      <GoogleAnalytics/>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">Privacy Policy</h1>
          </div>
        </div>
      </section>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At SHREE Tours & Travels, we prioritize your privacy and are committed to safeguarding your personal information. This Privacy Policy outlines the data we collect, how we use it and how we protect it.
              </p>

              <div className="section">
                <p className="highlight ">Information We Collect:</p>
                <p className="highlight ">1. Personal Information:</p>
                <p>
                  We collect personal details such as name, phone number, email and payment details to provide seamless travel services.
                </p>

                <p className="highlight ">2. Usage Data:</p>
                <p>
                  We collect browsing data like IP address, device information and interaction patterns for website improvement.
                </p>

                <p className="highlight ">3. Location Data:</p>
                <p>
                  With your consent, we collect location data for accurate ride services and better user experience.
                </p>
              </div>

              <div className="section">
                <p className="highlight ">How We Use Your Information:</p>
                <p className="highlight ">1. Service Delivery:</p>
                <p>
                  We use your details for booking confirmations, ride tracking and payment processing.
                </p>

                <p className="highlight ">2. User Experience Enhancement:</p>
                <p>
                  Data helps us improve our platform, solve issues and introduce better features.
                </p>

                <p className="highlight ">3. Communication:</p>
                <p>
                  We send booking details, ride updates and service notifications via SMS and email.
                </p>

                <p className="highlight ">4. Marketing & Promotions:</p>
                <p>
                  With your permission, we send special offers, discounts and service updates.
                </p>
              </div>

              <div className="section">
                <p className="highlight ">Information Sharing:</p>
                <p className="highlight ">1. Trusted Partners:</p>
                <p>
                  We share relevant data with trusted partners for payment processing and customer support.
                </p>

                <p className="highlight ">2. Legal Compliance:</p>
                <p>
                  We may disclose information when required by law or to protect our rights and safety.
                </p>
              </div>

              <div className="section">
                <p className="highlight ">Data Security:</p>
                <p>
                  We implement security measures to protect your data but cannot guarantee absolute security against cyber threats.
                </p>

                <p className="highlight ">Your Rights:</p>
                <p>
                  You can request access, updates, or deletion of your personal data. Opt-out options for marketing communications are available.
                </p>

                <p className="highlight ">Policy Updates:</p>
                <p>
                  We may update our privacy policy periodically. We encourage you to review it regularly.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any privacy concerns, reach out to us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+919594917913">+91 9594917913</a></li>
              <li><b>Email:</b> <a href="mailto:booking@shreecabs24.com">booking@shreecabs24.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
